export default (year, data) => {
  const filteredByYear = data.filter(datum => datum.year === year && datum.source !== 'derived')
  const dataForYear = {}
  for (const datum of filteredByYear) {
    if (!dataForYear[datum.category]) {
      dataForYear[datum.category] = datum
    } else if (dataForYear[datum.category].createdAt < datum.createdAt) {
      dataForYear[datum.category] = datum
    }
  }
  return Object.values(dataForYear)
}